<template>
  <div
    id="container-geo"
    class="container-geo"
  ></div>
</template>

<script>
import * as Highcharts from 'highcharts/highmaps';
import { COLORS } from '@/common/utils/constants';

export default {
  name: 'GeoChart',
  props: {
    color: {
      type: String,
      required: true,
    },
    values: {
      // Example: [["nl-gr", "4.8"], ["nl-zh", "6.0"]]
      type: Array,
      required: true,
    },
    height: {
      type: Number,
      default() {
        return 400;
      },
    },
    maxValue: {
      type: Number,
      default() {
        return 10;
      },
    },
    countryCode: {
      type: String,
      default() {
        return 'nl';
      },
    },
  },
  methods: {
    async createChart() {
      const topology = await fetch(
        `https://code.highcharts.com/mapdata/countries/${this.countryCode}/${this.countryCode}-all.topo.json`,
      ).then((response) => response.json());

      Highcharts.mapChart('container-geo', {
        chart: {
          map: topology,
          height: this.height,
          backgroundColor: 'transparent',
        },

        title: {
          text: '',
        },

        mapNavigation: {
          enabled: false,
        },
        colorAxis: {
          min: 0,
          max: this.maxValue,
          maxColor: this.color,
          minColor: '#e6ebf5',
        },
        credits: {
          enabled: false,
        },
        series: [{
          data: this.values,
          type: 'map',
          states: {
            hover: {
              color: '#8897AA',
            },
          },
          dataLabels: {
            enabled: true,
            format: '{point.value}',
            color: COLORS.black,
            style: {
              textOutline: 0,
            },
          },
        }],
      });
    },
  },
  mounted() {
    this.createChart();
  },
};
</script>

<style scoped>
.container-geo {
  width: 100%;
}
</style>
